<template>
  <div>
    <card-info title="Pedidos apenas para retirada" icon="address" v-if="empresa.tipo_delivery === '2'">
      <div class="small">
        <b class="text-success">Grátis</b>
        <span v-if="!agendamento"> / {{ empresa.media_retirada | tempo }}</span>
      </div>
    </card-info>
    <router-link :to="`${url}/perfil/enderecos?home=true`" v-else-if="token && usuario.id_endereco && usuario.taxa_entrega !== null">
      <card-info :title="`${usuario.logradouro}, ${usuario.numero}`" icon="delivery" icon-pos="fa-angle-right">
        <div class="small" v-if="usuario.raio_empresa !== '1'">
          <span v-if="empresa.limitar_cidade === '1' && usuario.id_cidade !== empresa.id_cidade">Sentimos muito, entregamos apenas em <b>{{ empresa.nome_cidade }} - {{ empresa.sigla_estado }}</b></span>
          <span v-else>Sentimos muito, mas não entregamos em sua localização</span>
        </div>
        <div class="small" v-else>
          <span v-if="usuario.entrega_gratis !== '1' && usuario.taxa_entrega > 0">{{ usuario.taxa_entrega | valor }}</span>
          <b class="text-success" v-else>Entrega Grátis</b>
          <span v-if="usuario.tempo_entrega > 0 && !agendamento"> / {{ usuario.tempo_entrega | tempo }}</span>
          <span v-if="empresa.geo_disabled === '0' && usuario.distance > 100"> / {{usuario.distance | kilometer}}</span>
        </div>
      </card-info>
    </router-link>
    <a href="javascript:" @click="openModal" v-else>
      <card-info :title="taxa ? taxa.nome : 'Consultar taxa e tempo'" icon="address" icon-pos="fa-angle-right">
        <div class="small" v-if="taxa">
          <span v-if="taxa.valor > 0">{{ taxa.valor | valor }}</span><b class="text-success" v-else>Grátis</b>
          <span v-if="taxa.tempo > 0 && !agendamento"> / {{ taxa.tempo | tempo }}</span>
        </div>
        <div class="small" v-else-if="empresa.tipo_delivery === '1'">Entregas e retiradas</div>
        <div class="small" v-else>Clique para consultar</div>
      </card-info>
    </a>
    <modal-tempo ref="tempo" @close="opened=false" :agendamento="agendamento"/>
  </div>
</template>

<script>
import CardInfo from "./CardInfo";
import ModalTempo from "./ModalTempo";

export default {
  name: "TaxaTempo",
  components: {ModalTempo, CardInfo},
  data() {
    return {
      token: localStorage.getItem('token'),
      agendamento: false,
      opened: false,
      url: ''
    }
  },

  methods: {
    closeModal() {
      this.$refs.tempo.closeModal();
    },

    openModal() {
      this.opened = true;
      this.$refs.tempo.abrirModal();
    }
  },

  mounted() {
    this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';
    this.agendamento = this.empresa.ativo === '1' && this.empresa.aberto === '0' && this.empresa.entregas.length;
  },

  computed: {
    usuario() {
      return this.$store.state.dataUser
    },

    empresa() {
      return this.$store.state.empresa
    },

    taxa() {
      return this.$store.state.taxa
    }
  }
}
</script>

<style scoped>

</style>